import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params, Router }   from '@angular/router';
import { Http, Response, ResponseContentType } from '@angular/http';
import { Location } from '@angular/common';

import { RequestService } from '../services/request.service';
import { ProviderService } from '../services/providers/provider.service';
import { SpecialtiesService } from '../services/specialties/specialties.service'
import { SpecialtyProviderConfig } from '../classes/specialtyProviderConfig';

import * as moment from 'moment';
import * as _ from 'lodash';
import { SpecialtyProviderConfigService } from '../services/specialtyProviderConfig/specialty-provider-config.service';



@Component({
  selector: 'specialty-provider-config',
  templateUrl: './specialty.provider.config.component.html',
  styleUrls: ['./specialty.provider.config.component.css']
})
export class SpecialtyProviderConfigComponent implements OnInit {

  specialtyProviderConfig:SpecialtyProviderConfig = new SpecialtyProviderConfig();
  updatedConfig: any = new SpecialtyProviderConfig();
  specialtyName: string;
  providerName: string;

  loading:boolean=false
  changeAlert:boolean=false;
  noChangesAlert:boolean=false;
  url:string;

  closeChangeAlert(){
    this.changeAlert=false;
  }
  closeNoChangeAlert(){
    this.noChangesAlert=false;
  }

  //specialty config availableHours
  checkBoxDays= [
    { day: 'D',    selected: false },
    { day: 'L',   selected: false },
    { day: 'Ma',     selected: false },
    { day: 'Mi', selected: false },
    { day: 'J',   selected: false },
    { day: 'V',     selected: false },
    { day: 'S', selected: false }
  ];

  wh = []
  newWH={from:new Date(),to:new Date()}
  addWH:boolean=false;
  selectedDay:any;
  days=['D','L','M','Mi','J','V','S'];
  indexWH:any; //para delete wh
  addedWh:any[]=[]
  deletedWh:any[]=[]
  whChanged:boolean=false

  /*ALERTAS*/
  alertBlank:boolean=false;
  alertHour:boolean=false;
  alertDay:boolean=false;
  alertExist:boolean=false;
  alertTime:boolean=false;
  alertDelete:boolean=false;

  closeAlertBlank(){
    this.alertBlank=false;
  }
  closeAlertHour(){
    this.alertHour=false;
  }
  closeAlertDay(){
    this.alertDay=false;
  }
  closeAlertExist(){
    this.alertExist=false;
  }
  closeAlertTime(){
    this.alertTime=false;
  }
  closeAlertDelete(){
    this.alertDelete=false;
  }
  /*alertas*/

  constructor(protected specialtyProviderService:SpecialtyProviderConfigService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected requestService:RequestService,
    protected providerService:ProviderService,
    protected specialtiesService:SpecialtiesService,
    protected location: Location,
    private http: Http) { }

  ngOnInit() {
    var providerId = this.route.snapshot.params['providerId'];
    var specialtyId = this.route.snapshot.params['specialtyId'];
    this.route.params
      .switchMap((params: Params) => this.specialtyProviderService.getByProviderAndSpecialty(params['providerId'], params['specialtyId'])
      )
      .subscribe((specialtyConfig) => {
        if(_.isEmpty(specialtyConfig)) {
          this.specialtyProviderConfig = new SpecialtyProviderConfig();
          Promise.all( [
            this.providerService.getOne(providerId),
            this.specialtiesService.getOne(specialtyId)
          ] ).then( (promises) => {
            this.specialtyProviderConfig.provider = promises[0];
            this.specialtyProviderConfig.specialty = promises[1];
            this.startObject(this.specialtyProviderConfig)
          });
        } else {
          this.specialtyProviderConfig = specialtyConfig;
          this.startObject(specialtyConfig)
        }
      });
  }

  startObject(specialtyConfig) {
    this.updatedConfig = _.clone(specialtyConfig);
    this.specialtyName = specialtyConfig.specialty.name;
    this.providerName = specialtyConfig.provider.name;
    this.fillObject();
    this.loading=false;
  }

  goBack(){
    this.location.back();
  }

  save(): void {

    let updatedFields: any = this.getUpdatedFields();

    if (_.isEmpty(updatedFields) && this.url==undefined) {
      alert("There are no changes to save");
      return;
    }

    if(!_.isEmpty(this.specialtyProviderConfig.id))
      this.specialtyProviderService.update(this.specialtyProviderConfig.id, updatedFields).then(() => this.goBack())
    else
      this.specialtyProviderService.create(updatedFields).then(() => this.goBack())
  }

  protected getUpdatedFields(): any {
    let updatedFields
    if (this.whChanged)
    {
      updatedFields = _.merge(this.specialtyProviderConfig, this.updatedConfig);
      updatedFields.availableHours = this.getWhFormat();
      updatedFields.provider = updatedFields.provider.id;
      updatedFields.specialty = updatedFields.specialty.realId;
    }
    return updatedFields;
  }

  selectDay(day){
    this.selectedDay=day;
  }

  addNewWH(){
    this.addWH=true;
  }

  deleteWH(index){
    this.indexWH=index;
    this.alertDelete=true;
  }

  delete(){
    this.whChanged =true
    let daysOfHour = this.updatedConfig.availableHours[this.selectedDay.hours[this.indexWH]]
    this.wh[this.selectedDay.i].hours.splice(this.indexWH,1)
    if (this.wh[this.selectedDay.i].hours.length==0){
      this.wh[this.selectedDay.i].available=false
      this.selectedDay=undefined
    }

  }

  getWhFormat(){
    let updated={}
    for (let i=0;i<this.wh.length;i++){
      for (let j=0;j<this.wh[i].hours.length;j++){
        if (!updated[this.wh[i].hours[j]]) updated[this.wh[i].hours[j]]=[i]
        else updated[this.wh[i].hours[j]].push(i)
      }
    }

    return updated
  }

  submitWH(){
    this.alertBlank=false;
    this.alertDay=false;
    this.alertExist=false;
    this.alertHour=false;
    this.alertTime=false;

    let from:any = moment(this.newWH.from).format('HH:mm')
    let to:any = moment(this.newWH.to).format('HH:mm')
    if (typeof(from)!='string' || typeof(to)!='string'){
      this.alertBlank=true
      return
    }
    if (from==to){
      this.alertHour=true;
      return
    }

    if (moment(from,'HH:mm') > moment(to,'HH:mm')){
      this.alertTime=true;
      return
    }


    let finalDays:any[]=[]
    for (let i=0;i<this.checkBoxDays.length;i++){
      if (this.checkBoxDays[i].selected==true) {
        finalDays.push(i)
      }
    }
    this.alertDay = finalDays.length == 0
    if (this.alertDay){
      return;
    }

    if (!this.isPossible(from,to,finalDays)){
        this.alertExist=true;
        return;
      }

    from = moment(from,'HH:mm').format('HH.mm')
    to = moment(to,'HH:mm').format('HH.mm')
    let wh=from+'-'+to
    this.addedWh.push({hour:wh,days:finalDays})
    //Para que se actualice la pantalla con el nuevo available hour
    this.whChanged=true;
    for(let i=0;i<finalDays.length;i++){
      this.wh[finalDays[i]].available=true
      this.wh[finalDays[i]].hours.push(wh)
    }
  }

  fillObject(){
    //fill available hour array for the html
    if (this.updatedConfig !== undefined){
      var arr = [];
      var obj = this.updatedConfig.availableHours;
      for (var prop in obj) {
        arr.push({key:prop,value:obj[prop]})
      }
      for (let i=0;i<this.days.length;i++){
        this.wh.push({day:this.days[i],available:false,hours:[],i:i});
      }

      for (let i=0;i<arr.length;i++){
        for (let j=0;j<arr[i].value.length;j++){
          this.wh[arr[i].value[j]].available=true
          this.wh[arr[i].value[j]].hours.push(arr[i].key);
        }
      }
    }
  }

  isPossible(newFrom,newTo,days:any[]):boolean{
    let hours:any[]
    let from,to
    for (let i=0;i<days.length;i++){
      hours=this.wh[days[i]].hours
      for (let j=0;j<hours.length;j++){
        from=hours[j].slice(0,5)
        to=hours[j].slice(6,11)
        from=moment(from,'HH.mm').format('HH:mm')
        to=moment(to,'HH.mm').format('HH:mm')

        // a-si el nuevo horario esta entre la available hour
        if (from >= newFrom && from < newTo) return false
        if (to > newFrom && to <=newTo) return false

        // b-si la available hour esta entre el nuevo horario
        if (newFrom >= from && newFrom < to) return false
        if (newTo > from && newTo <=to) return false
      }
    }
    return true
  }

}



// WEBPACK FOOTER //
// ./src/app/specialty-provider-config/specialty.provider.config.component.ts